import { render, staticRenderFns } from "./HistoryProjectDialog.vue?vue&type=template&id=bd423b4c&scoped=true"
import script from "./HistoryProjectDialog.vue?vue&type=script&lang=js"
export * from "./HistoryProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryProjectDialog.vue?vue&type=style&index=0&id=bd423b4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd423b4c",
  null
  
)

export default component.exports